import { render, staticRenderFns } from "./AddCategorie.vue?vue&type=template&id=1a2178c0&"
import script from "./AddCategorie.vue?vue&type=script&lang=js&"
export * from "./AddCategorie.vue?vue&type=script&lang=js&"
import style0 from "./AddCategorie.vue?vue&type=style&index=0&id=1a2178c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports